import React from "react";

const SvgMessenger = props => <svg width={20} height={9} viewBox="0 0 20 9" id="messenger" y={62} {...props}><polygon fill="#fff" fillRule="nonzero" points="11.5789474 9 7.65550239 4.78723404 0 9 8.42105263 0 12.4401914 4.21276596 20 0" /></svg>;

export default "//cdn.scentbird.com/assets/frontbird-site/images/messenger_7aae22.svg";
export { SvgMessenger as ReactComponent };